export default __webpack_public_path__ + "static/media/edit.1136af1b.svg";